import { HttpContext } from '@angular/common/http';

import { isEmpty } from 'lodash';

import { REQUEST_CALLER_IDENTIFY } from '@services/interceptors/http-context-tokens';

export const buildIdentifyContext = (identify: string): HttpContext => {
    const context = new HttpContext();

    if (!isEmpty(identify) && !context.get(REQUEST_CALLER_IDENTIFY)) {
        context.set(REQUEST_CALLER_IDENTIFY, identify);
    }

    return context;
};
